import React, { useState } from 'react'
import { styled } from '@mui/material/styles';
import Typography from "@mui/material/Typography";
import ClearIcon from '@mui/icons-material/Clear';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom/dist';
import { useSelector } from 'react-redux';

const PREFIX = 'EmailSnackBar';

const classes = {
  root: `${PREFIX}-root`,
  isHidden: `${PREFIX}-isHidden`,
  closeIcon: `${PREFIX}-closeIcon`,
  contentContainer: `${PREFIX}-contentContainer`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.root}`]: {
    width: '100%',
    cursor: 'pointer',
    backgroundColor: 'rgb(211,175,95)',
    borderBottom: '1px solid #343434',
    padding: '0.5rem',
    zIndex: 1050,
    position: 'fixed',
    top: '64px',
    height: '40px',
  },

  [`& .${classes.isHidden}`]: {
    display: 'none',
    height: 0,
  },

  [`& .${classes.closeIcon}`]: {
    cursor: 'pointer',
    marginLeft: '1rem',
  },

  [`& .${classes.contentContainer}`]: {
    display: 'flex',
    justifyContent: 'center',
  }
}));

const EmailSnackBar = (props) => {

  const [isOpen, setIsOpen] = useState(true);
  const headerHidden = useSelector(state => state.myExpariences.headerHidden)
  const history = useNavigate();
  const { t } = useTranslation();

  return (
    <Root>
      <div
        className={isOpen ? classes.root : classes.isHidden}
        style={{
          top: props.isResponsive && headerHidden ? 0 : props.isResponsive ? '55px' : '64px',
          'WebkitTransition': 'all .3s ease',
          'MozTransition': 'all .3s ease',
          'OTransition': 'all .3s ease',
          'Transition': 'all .3s ease',
        }}
      >
        <div
          className={classes.contentContainer}
          onClick={() => history('/account')}
        >
          <Typography variant="body1">
            {t('account.provideEmail')}
          </Typography>
          <ClearIcon
            onClick={(e) => {
              e.stopPropagation();
              setIsOpen(false);
            }}
            className={classes.closeIcon}
          />
        </div>
      </div>
    </Root>
  );
}

export default EmailSnackBar;